import React, { useContext, useState } from 'react';
import { Button } from '@warp-ds/react';
import ChevronUp from '@warp-ds/icons/react/chevron-up-16';
import ChevronDown from '@warp-ds/icons/react/chevron-down-16';
import { useLingui } from '@lingui/react';
import TranslationContext from '../translation-context.js';

export type PurposeType = {
    purpose: Purpose;
    children: React.ReactNode;
    text: string;
};

function Readmore({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    const { i18n } = useLingui();
    const { texts } = useContext(TranslationContext);
    const [active, setActive] = useState(false);
    const toggle = () => setActive(!active);
    return (
        <>
            <Button
                onClick={toggle}
                aria-expanded={active}
                className="flex items-center"
                secondary
                small
                quiet
            >
                <span className="mr-4 text-xs">
                    {active
                        ? i18n.t({
                              id: 'privacy-settings.read-less',
                              comment: 'Read less link',
                              values: texts,
                          })
                        : i18n.t({
                              id: 'privacy-settings.read-more',
                              comment: 'Read more link',
                              values: texts,
                          })}
                </span>
                {active ? <ChevronUp /> : <ChevronDown />}
            </Button>
            <div className={active ? 'block pt-8' : 'hidden'}>{children}</div>
        </>
    );
}

export default function Purpose(props: PurposeType): React.ReactElement {
    return (
        <div className="purpose mt-4">
            <h3 className="text-m">{props.purpose.heading}</h3>
            <div className="flex">
                <div className="grow text-s pr-16">
                    <p>{props.text}</p>
                    <Readmore>
                        <p className="whitespace-pre-line">
                            {props.purpose.description}
                        </p>
                    </Readmore>
                </div>
                <div>{props.children}</div>
            </div>
        </div>
    );
}
